<template>
  <header
    class="header-text"
    :class="{ '--dark': color === 'dark', '--white': color === 'white' }"
  >
    <span v-if="label !== ''" class="-decor">{{ label }}</span>
    <h2 v-if="title !== ''">{{ title }}</h2>
  </header>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style lang="scss" scoped>
.header-text {
  text-align: center;
  h2 {
    font-size: 42px;
    color: $white;
    position: relative;
    text-align: center;

    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: -25px;
      width: 2px;
      // height: calc(100% - 11px);
      height: 32px;
      background: $yellow;
    }
  }

  &.--dark {
    .-decor {
      color: $gray;
    }

    h2 {
      color: $dark-grey;
    }
  }

  &.--white {
    .-decor {
      color: $yellow;
    }
    h2 {
      color: $white;
    }
  }
}

@media screen and (max-height: 800px) {
  .header-text {
    h2 {
      margin-bottom: 15px;
      font-size: 36px;

      &::before {
        height: 26px;
      }
    }
  }
}
</style>
